import { render, staticRenderFns } from "./ModifyGrade.vue?vue&type=template&id=1bb31e5b&scoped=true&"
import script from "./ModifyGrade.vue?vue&type=script&lang=ts&"
export * from "./ModifyGrade.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyGrade.vue?vue&type=style&index=0&id=1bb31e5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb31e5b",
  null
  
)

export default component.exports